module.exports = __webpack_public_path__ + "img/withdraw_offer.757f17cd.svg";